export function withApplicationUrl(path) {
  const url = process.env.REACT_APP_API_HOSTNAME.slice(0, -1);
  return ['http://', 'https://'].some((http) => path.includes(http))
    ? path
    : url + path;
}
